import { instance as axios } from "@/store/_AXIOS"
import { _TOKEN, _DECODE } from "@/store/_JWT"

const TABLE = "/notificacao/"
let isClicked = false

// initial state
const state = {
  data: []
}

// getters
const getters = {
  getAll: state => {
    return state.data
  }
}

// actions
const actions = {
  getByInstituicao({ commit }, id) {
    return axios
      .post(TABLE + "params/", _TOKEN({ id_instituicao: id }))
      .then(res => {
        _DECODE(res.data.data).then(r => {
          if (r) commit("setData", r)
          else commit("setData", null)
        })
      })
      .catch(err => {
        commit("setData", null)
      })
  },

  getNotificados({ commit }, id) {
    return axios
      .post("/notificacao_utilizador/params/", _TOKEN({ id_notificacao: id }))
      .then(res => {
        return _DECODE(res.data.data).then(r => {
          if (r) return r
          else return []
        })
      })
      .catch(err => {
        return []
      })
  },

  notificacao({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .post("/notificacao/", _TOKEN(params))
      .then(res => {
        dispatch("getByInstituicao", rootState.session.instituicao)
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? data : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
